import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Sidebar() {
    const [openMenus, setOpenMenus] = useState({});

    // Function to toggle submenu
    const toggleSubMenu = (menu) => {

        setOpenMenus((prev) => ({
            ...prev,
            [menu]: !prev[menu],
        }));
    };

    return (
        <div id="sidebar" className="sidebar responsive ace-save-state">
            <ul className="nav nav-list">
                <li className="active">
                    <Link to="/">
                        <i className="menu-icon fa fa-tachometer"></i>
                        <span className="menu-text"> Dashboard </span>
                    </Link>
                    <b className="arrow"></b>
                </li>
                <li className="">
                    <Link to="/student">
                        <i className="menu-icon fa fa-users"></i>
                        <span className="menu-text"> Stduent(s) </span>
                    </Link>
                    <b className="arrow"></b>
                </li>

                <li className={openMenus['project'] ? 'open' : 's'}>
                    <a href="#" onClick={() => toggleSubMenu('project')} className="dropdown-toggle">
                        <i className="menu-icon fa fa-desktop"></i>
                        <span className="menu-text"> UI & Elements </span>
                        <b className="arrow fa fa-angle-down"></b>
                    </a>
                    <b className="arrow"></b>

                    <ul className={`submenu ${openMenus['project'] ? 'open' : ''}`} style={{ display: openMenus['project'] ? 'block' : 'none' }}>
                        <li>
                            <Link to="/project/about" className='active'>
                                <i className="menu-icon fa fa-caret-right"></i>
                                About
                            </Link>
                        </li>
                        <li>
                            <Link to="/elements">
                                <i className="menu-icon fa fa-caret-right"></i>
                                Elements
                            </Link>
                        </li>
                        <li>
                            <Link to="/buttons">
                                <i className="menu-icon fa fa-caret-right"></i>
                                Buttons & Icons
                            </Link>
                        </li>
                    </ul>
                </li>

                <li className={openMenus['tables'] ? 'open' : ''}>
                    <a href="#" onClick={() => toggleSubMenu('tables')} className="dropdown-toggle">
                        <i className="menu-icon fa fa-list"></i>
                        <span className="menu-text"> Tables </span>
                        <b className="arrow fa fa-angle-down"></b>
                    </a>
                    <b className="arrow"></b>

                    <ul className={`submenu ${openMenus['tables'] ? 'open' : ''}`} style={{ display: openMenus['tables'] ? 'block' : 'none' }}>
                        <li>
                            <Link to="/tables">
                                <i className="menu-icon fa fa-caret-right"></i>
                                Simple & Dynamic
                            </Link>
                        </li>
                        <li>
                            <Link to="/jqgrid">
                                <i className="menu-icon fa fa-caret-right"></i>
                                jqGrid Plugin
                            </Link>
                        </li>
                    </ul>
                </li>
            </ul>

            <div className="sidebar-toggle sidebar-collapse" id="sidebar-collapse">
                <i id="sidebar-toggle-icon" className="ace-icon fa fa-angle-double-left ace-save-state" data-icon1="ace-icon fa fa-angle-double-left" data-icon2="ace-icon fa fa-angle-double-right"></i>
            </div>
        </div>
    );
}

export default Sidebar;
